import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IModule } from 'src/app/interfaces/IModule';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { PatientService } from 'src/app/services/patient.service';
import { paths } from 'src/component-paths/component-paths';
import { QuestionnaireHistoryItem } from 'src/app/interfaces/Questionnaire/IQuestionnaireHistory';
import { getQuestionnaireTemplateConfig } from 'src/app/constants/questionnaire-template-registry';
import { QuestionnaireNavigationService } from 'src/app/services/questionnaireNavigation.service';

@Component({
  selector: 'app-berg-and-gait-questionnaire',
  templateUrl: './berg-and-gait-questionnaire.component.html',
  styleUrl: './berg-and-gait-questionnaire.component.css',
  standalone: false,
})
export class BergAndGaitQuestionnaireComponent implements OnInit {
  @Input() modules?: IModule[];
  componentPaths = paths;
  @Input() selectedOption?: string;
  @Output() selectedOptionChange = new EventEmitter<string>();
  @Input() readonlyMode = false;
  @Input() overviewItemsByTemplateId: Record<
    number,
    QuestionnaireHistoryItem[]
  > = {};
  @Input() overviewLoading = false;
  @Input() overviewError = '';
  @Output() overviewRefreshRequested = new EventEmitter<void>();

  constructor(
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
    private readonly router: Router,
    private readonly questionnaireNavigationService: QuestionnaireNavigationService,
  ) {}

  ngOnInit() {}

  isVisitMode(): boolean {
    return (
      !!this.eocService.currentVisitId() &&
      (this.router.url.includes('episodeOfCare') ||
        this.router.url.includes('inPatientView'))
    );
  }

  currentVisitId(): string | number | undefined {
    return this.eocService.currentVisitId() || undefined;
  }

  currentPatientId(): string | undefined {
    return this.patientService.patientIDsignal() || undefined;
  }

  currentEpisodeOfCareId(): string | undefined {
    return this.eocService.currentEocId() || undefined;
  }

  getTemplateItems(templateId: number): QuestionnaireHistoryItem[] {
    return this.overviewItemsByTemplateId[templateId] ?? [];
  }

  openVisitQuestionnaire(templateId: number): void {
    const routeSection =
      getQuestionnaireTemplateConfig(templateId)?.routeSection;

    if (!this.isVisitMode() || !routeSection) {
      return;
    }

    this.questionnaireNavigationService.setTemplateContext(templateId);
    this.questionnaireNavigationService.openScreen({
      source: this.router.url.includes('inPatientView')
        ? 'inPatientView'
        : 'episodeOfCare',
      mode: 'visit-add',
      routeSection,
      questionnaireTemplateId: templateId,
    });
  }

  handleVisitQuestionnaireSubmitted(): void {
    this.overviewRefreshRequested.emit();
  }

  openQuestionnaireSubmission(item: QuestionnaireHistoryItem): void {
    const templateId = Number(item.questionnaireTemplateId ?? 0);
    const questionnaireId = item.questionnaireId?.toString();
    const routeSection =
      getQuestionnaireTemplateConfig(templateId)?.routeSection;

    if (!templateId || !questionnaireId || !routeSection) {
      return;
    }

    this.questionnaireNavigationService.setTemplateContext(templateId);

    const source = this.isVisitMode()
      ? this.router.url.includes('inPatientView')
        ? 'inPatientView'
        : 'episodeOfCare'
      : 'profile';

    this.questionnaireNavigationService.openScreen({
      source,
      mode:
        this.isVisitMode() && item.canEdit ? 'visit-edit' : 'profile-readonly',
      routeSection,
      questionnaireTemplateId: templateId,
      questionnaireDataId: questionnaireId,
    });
  }
}
